import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import toast from 'react-hot-toast';
import { QRCode } from 'react-qr-code';

import { ErrorMessage } from 'shared/base';

import { useMfaContext } from '@/components/mfa/providers/mfaProvider';

export const SetupMfaCard = () => {
  const { handleVerifyMfa, mfaSetupData, setVerifyMfaCode, verifyMfaCode } = useMfaContext();

  const qrSecret = mfaSetupData?.secret ?? '';
  const qrValue = mfaSetupData?.url ?? '';

  const handleCopy = () => {
    navigator.clipboard.writeText(qrSecret);
    toast.success('Copied to clipboard');
  };

  if (mfaSetupData && !mfaSetupData.secret && !mfaSetupData.url) {
    return (
      <Card>
        <CardContent sx={{ maxWidth: 664 }}>
          <ErrorMessage message="Failed to retrieve MFA setup data. Please try again later, or contact your organization administrator." />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent sx={{ maxWidth: 664 }}>
        <Typography variant="h5">Set up multi-factor authentication</Typography>
        <Typography variant="body1">
          Before continuing, your administrators require you to set up multi-factor authentication.
          You may use any supported authenticator app.{' '}
          <Link
            href="https://www.cloudquery.io/docs/platform/production-deployment/user-management/multi-factor-authentication"
            target="_blank"
          >
            More information
          </Link>
        </Typography>
        <Stack component="form" gap={3} onSubmit={handleVerifyMfa} py={3}>
          <Typography variant="body1">1. Scan the QR code with your authenticator app.</Typography>
          <Stack alignItems="center" direction="row" gap={3}>
            <Box sx={{ backgroundColor: 'white', borderRadius: 0.5, p: 0.5 }}>
              <QRCode size={135} value={qrValue} />
            </Box>
            <Stack gap={1}>
              <Typography>Can’t scan? Use this code instead:</Typography>
              <Stack alignItems="center" direction="row" gap={1}>
                <TextField
                  disabled={true}
                  sx={{ width: 370 }}
                  value={qrSecret}
                  variant="outlined"
                />
                <Button color="secondary" onClick={handleCopy}>
                  Copy
                </Button>
              </Stack>
            </Stack>
          </Stack>
          <Typography variant="body1">
            2. Enter 6-digit code from your authenticator app.
          </Typography>
          <Stack direction="row" gap={2}>
            <TextField
              fullWidth={true}
              label="Code"
              onChange={(e) => setVerifyMfaCode(e.target.value)}
              value={verifyMfaCode}
              variant="outlined"
            />
            <Button color="primary" sx={{ width: 150 }} type="submit" variant="contained">
              Set up MFA
            </Button>
          </Stack>

          <Stack alignItems="center" direction="row" gap={2} justifyContent="space-between">
            <Typography>Contact your organization&apos;s admin with any questions.</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
